var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box" }, [
    _c(
      "div",
      { staticClass: "box-body" },
      [
        _vm.isReady
          ? _c(
              "TemplateManagerTemplate",
              {
                attrs: {
                  id: _vm.template.Id,
                  name: _vm.template.Name,
                  subject: _vm.template.Subject,
                  sender: _vm.template.Sender,
                  "sender-name": _vm.template.SenderName,
                  "custom-css": _vm.template.Metadata.customCss,
                  locked: _vm.template.IsLocked,
                  pages: _vm.template.Pages,
                  templates: _vm.templateList,
                  parentId: _vm.template.ParentId,
                  created: _vm.parsedCreated,
                  modified: _vm.parsedModified,
                  state: _vm.template.State,
                  metadata: _vm.template.Metadata
                },
                on: {
                  "change-name": function($event) {
                    _vm.template.Name = $event
                  },
                  "change-subject": function($event) {
                    _vm.template.Subject = $event
                  },
                  "change-sender": function($event) {
                    _vm.template.Sender = $event
                  },
                  "change-sender-name": function($event) {
                    _vm.template.SenderName = $event
                  },
                  "change-custom-css": function($event) {
                    _vm.template.Metadata.customCss = $event
                  },
                  "set-parent": function($event) {
                    return _vm.setParent($event)
                  },
                  "lock-template": function($event) {
                    return _vm.toggleTemplateLock($event)
                  }
                }
              },
              [
                _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "col-11 mx-auto" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-12 mb-2" },
                        [
                          !_vm.isNewTemplate
                            ? _c("template-browser-preview-button", {
                                staticClass: "pull-right",
                                attrs: { "template-id": _vm.template.Id }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary pull-right ml-3",
                            on: { click: _vm.saveTemplateAsPublishable }
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.resource(
                                    "TemplateManager_SaveButton_Publishable_Text"
                                  )
                                ) +
                                "\n                            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.canSaveAsDraft
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary pull-right",
                                on: { click: _vm.saveTemplateAsDraft }
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.resource(
                                        "TemplateManager_SaveButton_Draft_Text"
                                      )
                                    ) +
                                    "\n                            "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ])
                  ])
                ])
              ]
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }